import $ from 'jquery';
import slick from 'slick-carousel';
import throttle from 'lodash/throttle';
import visible from './visible.js';
import Headroom from 'headroom.js';
 
/**
 * Variables
 */
 
const windowWidth = $(window).width();
const isDesktop = windowWidth <= 1200;
const isMd = windowWidth <= 1025;
const isTablet = windowWidth <= 768;
const isMobile = windowWidth <= 480;


/**
 * Mobile navigation toggle
 * @param  {mixed} event
 */

const toggleMenu = (event) => {
  event.preventDefault();

  $('.js-menu-toggle, .nav--header, .header__navigation').toggleClass('open');
  $('body').toggleClass('fixed');
  $('.header').toggleClass('menu-open');
  headroomInit();

};

$('.js-menu-toggle').on('click', toggleMenu);

/**
 * On Scroll: Animate visible items
 */

const $modules = $('.item--animate');

$(window).on('load scroll', throttle(() => {
  $modules.each((index, item) => {
    const $el = $(item);
    if($el.visible(true)) {
      $el.addClass('item--visible');
    }
  });
}, 300));


/**
 * Homepage animation
 */

$('.section--landing').on('mousewheel touchmove wheel', function() {
  homepageAnimation();
});

$(document).keydown(function(e){
  if ( e.which == 40 ) 
  { 
    homepageAnimation();
  }
});

function homepageAnimation() {
  var section = $('.section--landing');
  section.addClass('hide');
  $('.landing__header, .section__content-above, .landing__logo').addClass('hide');
  $('.header, .section--hero').removeClass('hidden'); 
  headroomInit();
  setTimeout( function() {
    $('body').removeClass('fixed');
    if  ( !$('.slider').hasClass('slick-initialized') )
    {
      sliderInit();
    }
  }, 500);
}


/* *
 * Slick Slider
 * */
 
function sliderInit() {
  $('[data-slider="slider"]').slick({
    slidesToShow: 1,
    arrows: true,
    dots: false,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 7000,
    infinite: true,
    cssEase: 'ease-out',
  });
}

$(window).on('load', function() {
  var section = $('.section--landing');
  if ( !section.length )
  {
    sliderInit();
    headroomInit();
  }
});


/* *
 * Headroom JS
 * */


const header = document.querySelector('header');
const nav = document.getElementById('header__navigation');

function headroomInit() { 
  if (isMd)
  {
    if ( $('.header__navigation').hasClass('open') ) 
    {
      $('header').removeClass().addClass('header');
    }
    else
    {
      const headroom = new Headroom(header);
      headroom.init(); 
    }
  }
  else
  {
    const headroom = new Headroom(header);
    headroom.init(); 
  }
}



/* *
 * Scrolling header background colour change
 * */

$(window).scroll(function() {
  var $window = $(window),
    $header = $('header'),
    $panel = $('.section');

  var scroll = $window.scrollTop();

  $panel.each(function() {
    var $this = $(this);
    var hero = 900;
    
    if ( scroll < hero )
    {
      $header.attr('data-section-colour', 'white' );
    }
    else if( $this.position().top <= scroll && $(this).position().top ) {

      var $bg_colour = $(this).data('section-colour');
      $header.attr('data-section-colour', $bg_colour );
      
    }
  });


}).scroll();
